import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './App.css';
// Import logo (you'll need to add your logo file to src/assets/images/)
import logo from './assets/images/green-logo-small.png';
import largeLogo from './assets/images/grow-logo.png';
import RainforestQuiz from './components/RainforestQuiz';
import EcoNews from './components/EcoNews';
import Events from './components/Events';
import WordSearch from './components/WordSearch';
import BirdCalls from './components/BirdCalls';
import TreeIdentification from './components/TreeIdentification';
import LanguageSelector from './components/LanguageSelector';
import RecyclingGame from './components/RecyclingGame';

// Game Components
const PlantCrossword = () => {
  const { t } = useTranslation();
  return <div className="page"><h2>{t('stubPages.plantCrossword.title')}</h2><p>{t('stubPages.plantCrossword.description')}</p></div>;
};
const RecycleGame = () => <RecyclingGame />;
const AnimalTracks = () => {
  const { t } = useTranslation();
  return <div className="page"><h2>{t('stubPages.animalTracks.title')}</h2><p>{t('stubPages.animalTracks.description')}</p></div>;
};
const TreeID = () => <TreeIdentification />;

// Other page stubs
const Welcome = () => {
  const { t } = useTranslation();
  return (
    <div className="welcome-page">
      <div className="welcome-content">
        <img src={largeLogo} alt="Grow to be Green Logo" className="welcome-logo" />
        <h1>{t('welcome.title')}</h1>
        <p>{t('welcome.description')}</p>
        <footer>{t('welcome.footer')}</footer>
      </div>
    </div>
  );
};
const News = () => <EcoNews />;
const HowToHelp = () => {
  const { t } = useTranslation();
  return <div className="page"><h2>{t('howToHelp.title')}</h2><p>{t('howToHelp.description')}</p></div>;
};
const Activities = () => {
  const { t } = useTranslation();
  return <div className="page"><h2>{t('activities.title')}</h2><p>{t('activities.description')}</p></div>;
};
const Shop = () => {
  return <div className="page"><h2>Shop</h2><p>Shop coming soon!</p></div>;
};
const Members = () => {
  const { t } = useTranslation();
  return <div className="page"><h2>{t('members.title')}</h2><p>{t('members.description')}</p></div>;
};

// Games component with sub-navigation
const Games = () => {
  const location = useLocation();
  const isGamesSection = location.pathname.startsWith('/games');
  const { t } = useTranslation();

  return (
    <div className="games-section">
      {isGamesSection && (
        <nav className="sub-nav">
          <ul className="sub-nav-list">
            <li><Link to="/games/rainforest-quiz">{t('games.rainforestQuiz')}</Link></li>
            <li><Link to="/games/word-search">{t('games.wordSearch')}</Link></li>
            <li><Link to="/games/bird-calls">{t('games.birdCalls')}</Link></li>
            <li><Link to="/games/tree-id">{t('games.treeIdentification')}</Link></li>
            <li><Link to="/games/plant-crossword">{t('games.plantCrossword')}</Link></li>
            <li><Link to="/games/recycle-game">{t('games.recycleGame')}</Link></li>
            <li><Link to="/games/animal-tracks">{t('games.animalTracks')}</Link></li>
          </ul>
        </nav>
      )}
      <div className="page">
        <Routes>
          <Route path="/" element={<div><h2>{t('games.title')}</h2><p>{t('games.description')}</p></div>} />
          <Route path="/rainforest-quiz" element={<RainforestQuiz />} />
          <Route path="/word-search" element={<WordSearch />} />
          <Route path="/plant-crossword" element={<PlantCrossword />} />
          <Route path="/recycle-game" element={<RecycleGame />} />
          <Route path="/bird-calls" element={<BirdCalls />} />
          <Route path="/animal-tracks" element={<AnimalTracks />} />
          <Route path="/tree-id" element={<TreeID />} />
        </Routes>
      </div>
    </div>
  );
};

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <Router>
      <header className="header">
        <div className="logo-container">
          <Link to="/" className="logo-link" onClick={() => setIsMenuOpen(false)}>
            <img src={logo} alt="Grow to be Green Logo" className="logo" />
            <h1 className="site-title">{t('nav.title')}</h1>
          </Link>
        </div>
        <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
        </button>
        <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
          <ul className="nav-list">
            <li className="language-selector-nav">
              <LanguageSelector />
            </li>
            <li><Link to="/games" onClick={() => setIsMenuOpen(false)}>{t('nav.games')}</Link></li>
            <li><Link to="/events" onClick={() => setIsMenuOpen(false)}>{t('nav.events')}</Link></li>
            <li><Link to="/news" onClick={() => setIsMenuOpen(false)}>{t('nav.ecoNews')}</Link></li>
            <li><Link to="/how-to-help" onClick={() => setIsMenuOpen(false)}>{t('nav.howToHelp')}</Link></li>
            <li><Link to="/activities" onClick={() => setIsMenuOpen(false)}>{t('nav.ecoActivities')}</Link></li>
            <li><Link to="/members" onClick={() => setIsMenuOpen(false)}>{t('nav.members')}</Link></li>
          </ul>
        </nav>
      </header>
      <main>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/games/*" element={<Games />} />
          <Route path="/events" element={<Events />} />
          <Route path="/news" element={<News />} />
          <Route path="/how-to-help" element={<HowToHelp />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/members" element={<Members />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
